/**
* @file 安检员账号
* */
<template>
  <div id="member">

    <!-- 模态框 -->
    <el-dialog :visible.sync="dialogVisible" :title="`${form.id ? '编辑' : '创建'}账号`"
      @close="$refs.form.resetFields(); form.id = null;" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select :disabled="form.id ? true : false" v-model="form.organizationId" filterable
            v-if="mixinUserInfo && mixinUserInfo.organizationType == 1">
            <el-option
              v-for="(                      item, i                      ) in                      organizations                      "
              :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
        </el-form-item>

        <el-form-item label="登录手机号" prop="phone">
          <el-input v-model="form.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="安检员名称" prop="name">
          <el-input v-model="form.name" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :required="form.id ? false : true">
          <el-input v-model="form.password" type="password" autocomplete="new-password" maxlength="12"></el-input>
        </el-form-item>
        <el-form-item label="安检权限" prop="securityOrganizationId">
          <div style="color:#999">控制账号在安检员端中，能否查询到其他机构的车辆数据</div>
          <el-checkbox-group v-model="form.securityOrganizationId">
            <el-checkbox
              v-for="(                    item, index                    ) in                     organizationList                    "
              :key="index" :label="String(item.id)" :disabled="item.type == 1">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item style="margin-top: 50px; text-align: right;">
          <el-button @click=" dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="创建安检员账号" @addFn="addFn">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click=" compileClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i v-if="mixinUserInfo.id !== row.id" class="iconfont icon-delete" @click=" removeClick(row)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>

  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/inspector',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        }
      },
      columns: [
        { prop: 'phone', label: '登录手机号' },
        { prop: 'name', label: '安检员名称' },
        { prop: 'securityOrganizationName', label: '安检员权限' },
        { prop: 'created', label: '创建时间' }
      ],

      dialogVisible: false,
      organizationList: [],
      form: { organizationId: null, securityOrganizationId: [] },
      rules: {
        organizationId: [{ required: true, message: '请选择机构名称' }],
        phone: [
          { required: true, message: '请输入登录手机号' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }
        ],
        name: [{ required: true, message: '请输入安检员名称' }],
        password: [{
          validator: (rule, value, callback) => {
            let reg = /^.{6,12}$/
            if (!this.form.id) {
              if (!value && value !== 0) {
                callback(new Error('请输入密码'))
              } else if (!reg.test(value)) {
                callback(new Error('请输入6-12位的密码'))
              } else {
                callback()
              }
              callback()
            } else {
              if ((value || value == 0) && !reg.test(value)) {
                callback(new Error('请输入6-12位的密码'))
              } else {
                callback()
              }
            }
          }
        }],
        securityOrganizationId: [{ required: true, message: '请选择安检员权限' }]
      },
      loading: false,

    }
  },
  async created() {
    await this.mixinOrganizations()
    this.getOrganizationList()
    if (!this.id && this.mixinUserInfo && this.mixinUserInfo.organizationType == 2) {
      if (this.organizations && this.organizations[0] && this.organizations[0].id) {
        this.organizationId = this.organizations[0].id
      }
    }
  },
  methods: {
    /* 点击创建成员 */
    addFn() {
      this.form.organizationId = this.mixinUserInfo.organizationId;
      this.form.securityOrganizationId = [String(this.organizationList[0].id)]
      this.dialogVisible = true;
    },
    /* 编辑角色 */
    compileClick(row) {
      this.form = { ...row, securityOrganizationId: row.securityOrganizationId.split(','), password: null };
      this.dialogVisible = true;
    },
    /* 删除角色 */
    removeClick(row) {
      let url = '/api/v1/manage/inspector/' + row.id
      this.$confirm('删除后该账户将无法登录，确认要删除吗?', '删除提示').then(async () => {
        let data = await this.$axios.delete(url)
        if (data && data.code == 1) {
          this.$message.success('删除成功')
          this.$refs.customTable.listFn()
        }
      })
    },
    /* 接口调用-获取角色列表 */
    async getOrganizationList() {
      let url = '/api/v1/manage/inspector/organization'
      let data = await this.$axios.get(url)
      if (data && data.code == 1) {
        this.organizationList = data.data;
      }
    },
    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },
    /* 接口请求-提交角色 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/inspector';
      let params = this.$utils.deepCopyFn(this.form);
      params.securityOrganizationId = params.securityOrganizationId.join(',')
      if (!params.password) { delete params.password }
      let data = await this.$axios[params.id ? 'put' : 'post'](url, params);
      this.loading = false;
      if (data && data.code == 1) {
        this.dialogVisible = false;
        this.$message.success('保存成功！')
        this.$refs.customTable.listFn();
      }
    },
  }
}
</script>

